import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { bonuses } from '../../data/bonuses';
export function BonusesSection() {
  return <section className="bg-surface px-5 py-20 md:py-28" data-id="element-74" data-mp="qcqukgjeg8uo">
      <div className="mx-auto max-w-6xl" data-id="element-75" data-mp="qe0t16u5zj1u">
        <div className="text-center" data-id="element-76" data-mp="vbu1k6ixwp5a">
          <p className="text-lg font-bold uppercase tracking-wide text-muted md:text-xl" data-id="element-77" data-mp="vcvded7s5fo2">No solo recibís los 5 volúmenes</p>
          <h2 className="mt-3 text-3xl font-black uppercase leading-tight tracking-tight text-ink md:text-5xl" data-id="element-78" data-mp="1j1wne4w9gyvg">
            También sumamos <span className="text-accent" data-id="element-79" data-mp="1o2c518nkssj8">5 bonos prácticos</span>
          </h2>
          <div className="mx-auto mt-6 h-0.5 w-16 bg-accent" aria-hidden="true" data-id="element-80" data-mp="19bbla7hdpc7s" />
        </div>

        <ul className="mt-14 flex flex-wrap justify-center gap-5" data-id="element-81" data-mp="1e8vag2fm79ei">
          {bonuses.map(b => <li key={b.label} className="flex w-full flex-col rounded-2xl border border-line bg-canvas p-7 sm:w-[calc(50%-0.625rem)] lg:w-[calc(33.333%-0.84rem)]" data-id="element-82" data-mp="21ypkydcgolvl">
              <div className="flex items-center gap-2.5" data-id="element-83" data-mp="2m4z3nnrpcp5i">
                <GiftIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-84" data-mp="2m3e8px1h7474" />
                <p className="text-sm font-extrabold uppercase tracking-widest text-accent" data-id="element-85" data-mp="2h7yxzdyrloex">{b.label}</p>
              </div>
              <h3 className="mt-3 text-xl font-black uppercase leading-tight text-ink md:text-2xl" data-id="element-86" data-mp="2vx4z57h5xopg">{b.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-muted md:text-lg" data-id="element-87" data-mp="34w06wnzuv6uv">{b.body}</p>
              <p className="mt-auto pt-5" data-id="element-88" data-mp="2zwxatt1usaz1">
                <span className="block border-t border-line pt-4 text-xs font-extrabold uppercase tracking-wide text-accent md:text-sm" data-id="element-89" data-mp="2zvvogsfe0220">
                  {b.highlight}
                </span>
              </p>
            </li>)}
        </ul>

        <div className="mt-14" data-id="element-90" data-mp="39t08allrflfn">
          <CtaButton data-id="element-91" data-mp="1kfn18om9jjau">Quiero acceder al MegaPack</CtaButton>
        </div>
      </div>
    </section>;
}